module.exports = __webpack_public_path__ + "img/1469004449.fd50e119.jpg";